import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { IomService } from 'src/app/services/iom.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { CategoryData } from 'src/app/models/DoughtnutDetails';
import { SessionService } from 'src/app/services/session.service';
import { forEach } from 'lodash';
import { BtInsightService } from 'src/app/services/charts.service';
// import { timeStamp } from 'console';
import { AppConfigService } from 'src/app/services/app-config.service';
import { data } from 'jquery';

declare var $: any;
declare var bootbox: any;

@Component({
  selector: 'app-trend-analysis',
  templateUrl: './trend-analysis.component.html',
  styleUrls: ['./trend-analysis.component.css']
})
export class TrendAnalysisComponent implements OnChanges {

  VersionId: string;
  IsOverAll = true;
  graphData: any;
  chartsData: any;
  chartTitleObject: any;
  CategoryName: string;
  categoryId: any;
  subCategoryId: any;
  userType: number;
  categoryList: any;
  subCategoryList: any;
  isForCategory; boolean;
  categoryOrSubcategoryName: string;
  totalTicketsCount: number;
  selectedSubCat_CategoryId: any;
  standardChartsRowrankings: number[];
  rowRankwiseData: any;
  allStandardChartsArray: string[];
  sChartGraphData: any;
  observationData: any;
  forecastObservation: any;
  forecastRowRank: number;
  scCatId: any;
  scSubCatId: any;
  observationText: string;
  envData: any;
  @Input() TextcategoryOrSubcategoryName: any;
  @Input() TextTicketCount: any;
  @Input() magicNumber: any;  
  scChartTitleList: any;
  constructor(public iomService: IomService
    , private spinner: NgxSpinnerService
    , private sessionservice: SessionService
    , private chartService: BtInsightService
    , private router: Router
    , private appConfigService: AppConfigService,) {
    this.envData = this.appConfigService.getEnvironment();
    this.standardChartsRowrankings = this.envData.scRowRankings.split(',');
  }
  ngOnChanges(changes: SimpleChanges) {
    //this.spinner.show();
    this.sChartGraphData = null;
    this.graphData = null;
    this.chartsData = {};
    this.spinner.show();
    this.VersionId = (localStorage.getItem("VersionIdMongo"));
    //localstorage value always string. To validate simple null , need to parse the string
    this.categoryId = JSON.parse(localStorage.getItem('CategoryId'));
    this.subCategoryId = JSON.parse(localStorage.getItem('SubCategoryId'));
    if (this.categoryId != '' && this.categoryId != null) {
      this.IsOverAll = false;
      this.getStandardChartsDetails();
      this.getCategorySubCategoryCharts();
    }
    else {
      this.IsOverAll = true;
      this.getStandardChartsDetails();
      this.LoadOverAllCharts(this.VersionId);
    }
    if (this.envData.instanceType == 'FDS') {
      this.forecastRowRank = 0;
    }
    else {
      this.forecastRowRank = -1;
    }
  }
  LoadOverAllCharts(VersionId) {
    //this.spinner.show();
    this.graphData = null;
    this.chartTitleObject = null;
    this.iomService.getSeverityHeatMapChart(VersionId).subscribe((data: any) => {
      if (data) {
        this.graphData = this.createObj(data.SeverityData);
        this.chartTitleObject = data.viewChartResponse;
        this.observationData = data.ObservationData;
        this.IsOverAll = true;
        // check default configuration
        $('#SelectAllInsights').prop('checked', true);
        this.chartTitleObject.forEach(element => {          
          if (element.IsEnabled == false) {
            $('#SelectAllInsights').prop('checked', false);
            return;
          }         
        });
      }
    },
      (err: HttpErrorResponse) => {
        console.log('Error Occured !');
      });
  }

  GetRowRank(key, IsSpliceRequired): number {
    if (!this.IsOverAll && this.graphData && this.graphData[key]) {
      key = Object.keys(this.graphData[key])[0];
    }
    else if (IsSpliceRequired) {
      key = key.slice(1);
    }

    if(key == "forcast" || this.envData.instanceType == 'SAAS_ManualUpload') // can change || to && when it is based on instanceType
    {
      this.forecastRowRank = -1;
    }
    return parseInt((key.indexOf(':|:') > -1 ? key.split(':|:')[1] : this.forecastRowRank));
  }
  GetChartTitle(key) {
    let rowRank = 0;
    if (this.IsOverAll) {
      key = key.slice(1);
      rowRank = this.GetRowRank(key, false);
    }
    else {
      rowRank = this.GetRowRank(key, true);
    }
    if (rowRank > 10000) {
      return this.GetSCChartTitle(rowRank, key);
    }
    else {
      let resultObject = this.chartTitleObject.find(x => x.RowRanking == rowRank);
      if (rowRank === this.forecastRowRank && this.TextcategoryOrSubcategoryName !=null) { //this condition is not satisfying for SAAS instance
     // if (rowRank === -1) {
        return 'Tickets related to ' + this.TextcategoryOrSubcategoryName;
      }
      if(rowRank === this.forecastRowRank){  // this condtion is added to work in AWS instancetype
        this.forecastRowRank = -1;
      }
      return resultObject.ChartHeading;
    }
  }
  // GetSCRowRank(key): number {
  //   // if (!this.sChartGraphData) {
  //   //   key = Object.keys(this.sChartGraphData[key])[0];
  //   // }
  //   return (key.indexOf(':|:') > -1 ? key.split(':|:')[1] : 0);
  // }
  GetSCChartTitle(rowRank, key) {
    let title = '';
    switch (rowRank) {
      case 10001:
        title = 'Turnaround Time'
        break;
      case 10002:
        title = 'Ticket Volume'
        break;
      default:
        let dimension = key.indexOf(':|:') > -1 ? key.split(':|:')[2] : '';
        title = "Tickets by " + dimension;
        break;
    }
    return title;
  }
  // Show/hide the overall level charts on eye icon/checkbox click
  ShowHideChart(chartTitle, rowRanking) {
    let selectedSubCateId = null;
    let selectedCatId = null;
    if (this.subCategoryId != '' && this.subCategoryId != null) {
      selectedCatId = this.categoryId !== undefined ? this.categoryId : null;
      selectedSubCateId = this.subCategoryId !== undefined ? this.subCategoryId : null;
    }
    else {
      selectedCatId = this.categoryId !== undefined ? this.categoryId : null;
      selectedSubCateId = null;
    }
    const request = [];
    if (chartTitle == 'all') {
      const status = $('input[name=\'domain-optionall\']:checked').length;
      const allVals = [];
      $.each($('input[name=\'domain-insights\']'), function () {
        allVals.push($(this).val());
      });
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < allVals.length; i++) {
        const data = this.chartTitleObject.filter(x => x.RowRanking == allVals[i]);
        const showhideDataRequest = {
          VersionId: this.VersionId,
          CategoryId: selectedCatId,
          SubCategoryId: selectedSubCateId,
          RowRanking: data[0].RowRanking,
          IsEnabled: status
        };
        request.push(showhideDataRequest);
      }
    }
    else {
      if ($('input[name=\'domain-insights\']:checked').length === this.chartTitleObject.length) {
        $('#SelectAllInsights').prop('checked', true);
      }
      else {
        $('#SelectAllInsights').prop('checked', false);
      }
      const data = this.chartTitleObject.filter(x => x.ChartHeading === chartTitle && x.RowRanking == rowRanking);

      const showhideDataRequest = {
        VersionId: this.VersionId,
        CategoryId: selectedCatId,
        SubCategoryId: selectedSubCateId,
        RowRanking: rowRanking,
        IsEnabled: data[0].IsEnabled ? 0 : 1
      };
      if(showhideDataRequest.IsEnabled==0)
      {
        bootbox.alert("Insight Hidden Successfully.");
      }
      request.push(showhideDataRequest);
    }
    this.spinner.show();
    // once user choose to hide the any chart at any level(overall/Cat/SubCat), we will call this API
    this.iomService.ShowHideChart(request).subscribe(response => {
      // here again we need to reload the overallcharts or category or subcategory charts based on the selection
      if (this.IsOverAll) {
        this.LoadOverAllCharts(this.VersionId);
      }
      else {
        this.getCategorySubCategoryCharts();
      }
      this.spinner.hide();
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log('Error Occured in show/hide the chart!');
      });
  }
  LoadInsights() {
    this.iomService.versionID = this.VersionId;
    this.iomService.isLoadInsight = true;
    this.iomService.rowRanking = null;
    this.iomService.isOverAll = this.IsOverAll;
    this.iomService.categoryId = this.categoryId == undefined ? null : this.categoryId;
    this.iomService.subCategoryID = this.subCategoryId == undefined ? null : this.subCategoryId;
    this.iomService.categoryName = this.TextcategoryOrSubcategoryName;
    setTimeout(() => {
      $('#addModal').modal('show'); 
    }, 1000);
  }
  EditInsight(RowRanking, VersionId, ChartTitle, Observation) {
    this.iomService.versionID = VersionId;
    this.iomService.rowRanking = RowRanking;
    this.iomService.isLoadInsight = true;
    this.iomService.chartTitle = ChartTitle;
    this.iomService.isOverAll = this.IsOverAll;
    this.iomService.categoryId = this.categoryId == undefined ? null : this.categoryId;
    this.iomService.subCategoryID = this.subCategoryId == undefined ? null : this.subCategoryId;
    this.iomService.categoryName = this.TextcategoryOrSubcategoryName;
    this.iomService.graphData = this.graphData;
    this.iomService.observation = this.GetObservationByRowRank(RowRanking);
    setTimeout(() => {
      $('#addModal').modal('show'); 
    }, 1000);
  }

  //Load category/Subcategory Details
  getCategorySubCategoryCharts() {
    this.graphData = null;
    this.chartTitleObject = null;
    this.isForCategory = (this.subCategoryId != '' && this.subCategoryId != undefined && this.subCategoryId != null) ? false : true;
    let catId = this.isForCategory ? this.categoryId : this.subCategoryId;
    // API to get the Category/Subcategory Charts Details    
    this.iomService.LoadCategorySubcategoryCharts(this.VersionId, catId, this.isForCategory).subscribe((data: any) => {
      if (data !== null) {
        this.sessionservice.setSessionStorageItem('nocallDDtiles', 'false');
        this.graphData = this.createObj(data.AreaBarCharts);
        // if (this.sChartGraphData) {
        //   //this.chartsData = { ...this.graphData, ...this.sChartGraphData }
        //   this.chartsData = this.createObj(this.sChartGraphData, this.graphData);
        //   this.spinner.hide();
        // }
        this.chartTitleObject = data.viewChartResponse;
        this.observationData = data.ObservationData;
        if (this.isForCategory) {
          this.forecastObservation = data.ObservationDataLevel5;
        }
        else {
          this.forecastObservation = data.ObservationDataLevel8;
        }
        this.IsOverAll = false;
        $('#SelectAllInsights').prop('checked', true);
        this.chartTitleObject.forEach(element => {          
          if (element.IsEnabled == false) {
            $('#SelectAllInsights').prop('checked', false);
            return;
          }         
        });
        //this.spinner.hide();
      }
    },
      (err: HttpErrorResponse) => {
        console.log('Error Occured !');
      });
  }
  navigateToCreatedeepdive() {
    switch (this.userType) {
      case 1:
        this.router.navigate(['createdeepdive']);
        break;
      case 3:
        const e2EUID = this.sessionservice.getE2EUId();
        const cMSUID = this.sessionservice.getCMSUId();
        const wSUID = this.sessionservice.getWSUId();
        this.router.navigate(['createdeepdive'], { queryParams: { E2EUId: e2EUID, CMSUId: cMSUID, WSUId: wSUID } });
        break;
      case 4:
        this.router.navigate(['createdeepdive'], { queryParams: { SolutionId: this.sessionservice.getSolutionId() } });
        break;
      default:
        break;
    }
  }
  getStandardChartsDetails() {
    this.spinner.show();
    this.sChartGraphData = null;
    let CategoryId = null;
    let SubCategoryId = null;
    this.rowRankwiseData = null;
    this.scChartTitleList = null;
    if (this.standardChartsRowrankings.length > 0) {
      if (this.subCategoryId != '' && this.subCategoryId != null) {
        CategoryId = this.categoryId == undefined ? null : this.categoryId;
        SubCategoryId = this.subCategoryId == undefined ? null : this.subCategoryId;
      }
      else if (this.categoryId != '' && this.categoryId != null) {
        CategoryId = this.categoryId == undefined ? null : this.categoryId;
        SubCategoryId = null;
      }
      else {
        CategoryId = null;
        SubCategoryId = null;
      }
      this.loadstandardcharts(CategoryId, SubCategoryId);

    }
  }
  async loadstandardcharts(CategoryId, SubCategoryId) 
  {
  let data : any;
  data = await Promise.all(this.standardChartsRowrankings.map(x => this.iomService.LoadStandardCharts(this.VersionId, CategoryId, SubCategoryId, x,10, [],false)));
  data.forEach(element => {
    this.rowRankwiseData = { ...this.rowRankwiseData, ...element.SeverityData };
    this.sChartGraphData = this.createObj(this.rowRankwiseData);
  });
  this.spinner.hide();
  }

  GetObservationByRowRank(rowRank) {
    let Observation;
    if (rowRank != this.forecastRowRank) {
      Observation = this.observationData.find(x => x.RowRanking == rowRank);
      return Observation != undefined || Observation != null ? Observation.ObservationDesc : 'Please enter your observations text here';
    }
    else {
      Observation = this.forecastObservation != undefined || this.forecastObservation != null ? this.forecastObservation[0].ObservationDesc : 'Please enter your observations text here';
      return Observation;
    }
  }
  GetObservation(key) {
    let rowRank = this.GetRowRank(key, true);
    let Observation;
    //Todo add instance type if FDS
    //if (this.envData.instanceType == 'FDS') {
    if (rowRank != this.forecastRowRank) {
      Observation = this.observationData.find(x => x.RowRanking == rowRank);
      return Observation != undefined || Observation != null ? Observation : 'Please enter your observations text here';
    }
    else {
      Observation = this.forecastObservation != undefined || this.forecastObservation != null ? this.forecastObservation[0] : 'Please enter your observations text here';
      return Observation;
    }
    //}
    // else{
    //   if (rowRank >= 0) {
    //     Observation = this.observationData.find(x => x.RowRanking == rowRank);
    //     return Observation != undefined || Observation != null ? Observation : 'Please enter your observations text here';
    //   }
    //   else {
    //     Observation = this.forecastObservation != undefined || this.forecastObservation != null ? this.forecastObservation[0] : 'Please enter your observations text here';
    //     return Observation;
    //   }
    // }
  }
  EditObservation(id) { // Observation Id
    if (id != 0) {
      var img = $("#editicon_" + id).attr('src');
      if (img == "assets/images/edit.svg") {
        this.observationText = document.getElementById("editobserv_" + id).textContent;
        document.getElementById("editobserv_" + id).contentEditable = "true";
        $("#editicon_" + id).attr('src', 'assets/images/check-icon.svg');
      }
      if (img == "assets/images/check-icon.svg") {
        document.getElementById("editobserv_" + id).contentEditable = "false";
        $("#editicon_" + id).attr('src', 'assets/images/edit.svg');
        var editedObservation = document.getElementById("editobserv_" + id).textContent;
        this.iomService.updateobs(id, editedObservation, '', 0).subscribe(data => {
          this.spinner.hide();
          if (data == "Success") {
            document.getElementById("editobserv_" + id).contentEditable = "false";
          }
        }
          ,
          (err: HttpErrorResponse) => {
            this.spinner.hide();
            console.log("Error Occured !");
          });
      }
    }
  }

  //Reset Observation
  ResetObservation(id) {
    var img = $("#editicon_" + id).attr('src');
    if (img == "assets/images/check-icon.svg") {
      $("#editicon_" + id).attr('src', 'assets/images/edit.svg');
      document.getElementById("editobserv_" + id).contentEditable = "false";
      document.getElementById("editobserv_" + id).textContent = this.observationText;
    }
  }
  editInsightsValues() {
    if (this.IsOverAll) {
      this.LoadOverAllCharts(this.VersionId);
    }
    else {
      this.getCategorySubCategoryCharts();
    }
  }
  createObj(data) { //scData, graphData) {
    let result = {};
    // let arr = [...Object.keys(scData)] //.concat(Object.keys(obj1))];
    // arr.forEach((v, i) => {
    //   result['A' + v] = scData[v];
    // });
    let arr1 = [...Object.keys(data)] //.concat(Object.keys(obj1))];
    if (!this.IsOverAll) {
      arr1.forEach((v, i) => {
        let isForecast = Object.keys(data[v])[0] == 'forcast';
        if (isForecast) {
          //result['B' + v] = data[v];
          result['A' + v] = data[v];
        }
        else {
          //result['C' + v] = data[v];
          result['B' + v] = data[v];
        }
      });
    }
    else {
      arr1.forEach((v, i) => {
        result['A' + v] = data[v];
      });
    }
    return result;
  }
}

